import * as React from 'react';

export interface DefaultEntityContextType {
  entityReference: string | null;
}

export default React.createContext<DefaultEntityContextType>({
  entityReference: sessionStorage.getItem('hub'),
});
